'use client'

import { languageNames, locales, localizedHref, splitLocale } from './config'
import { useLanguage } from './provider'
import { usePathname } from 'next/navigation'

export function LanguageSwitcher() {
  const { locale } = useLanguage()
  const pathname = usePathname()
  const path = splitLocale(pathname ?? '/').path
  if (/^\/shurink(?:\/|$)/.test(path) || /^\/rejuran\/[^/]+\/evidence(?:\/|$)/.test(path)) return null
  if (/^\/ulthera\/(?:v1\/)?side-effect(?:\/|$)/.test(pathname ?? '')) return null
  return <label translate="no" className="inline-flex shrink-0 items-center gap-1 text-12 text-ink-2">
    <span aria-hidden="true">◎</span>
    <select
      aria-label="Language"
      value={locale}
      onChange={event => {
        const next = event.target.value as typeof locale
        window.location.assign(localizedHref(window.location.pathname, next) + window.location.search + window.location.hash)
      }}
      className="min-h-[36px] max-w-[95px] cursor-pointer rounded border border-line-3 bg-surface-base px-2 text-12 text-ink-1 focus-visible:outline-accent-mint-400"
    >{locales.map(code => <option key={code} value={code}>{languageNames[code]}</option>)}</select>
  </label>
}
